import type { Product } from "@/contexts/product-context"
import { isProductEntitled } from "@/lib/mock/product-catalog"

/** Deployed Exam Management demo; owned opens leave the home shell for this app. */
export const EXAM_MANAGEMENT_HOSTED_APP_HREF =
  "https://5dba85bd.exxat-exammanagement.pages.dev/exam-management/course-offerings/c1"

const EXAM_MANAGEMENT_PRODUCT: Product = "exxat-exam-management"

export function getExamManagementHostedHref(): string | null {
  if (!isProductEntitled(EXAM_MANAGEMENT_PRODUCT)) return null
  return EXAM_MANAGEMENT_HOSTED_APP_HREF
}

export function openExamManagementHostedAppIfEntitled(): boolean {
  const href = getExamManagementHostedHref()
  if (!href) return false
  window.location.assign(href)
  return true
}
